import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';


export class ProjectDatesView extends Component {

	render() {
		const {  contractorSignatureDate, projectStartDate, finalDate } = this.props;
		return (
		
			<Card>
				<CardHeader title="Project : Dates" className='romis-card-header' />
				<CardContent>
					<TextField
						label="Contractor Signature Date :"
						value={contractorSignatureDate}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}

					/>

					<TextField
						label="Project Start Date :"
						value={projectStartDate}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}

					/>
					<TextField
						label="Final Date :"
						value={finalDate}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}

					/>
				
				</CardContent>
			</Card>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/ProjectDatesView.js